import IParser from "@/types/IParser"
import ParseError from "@/types/ParseError"
import {
  IImbpSmartMeterInterest,
  SmartMeterInterestDetails,
} from "./imbpSmartMeterInterest.types"
import { ImbpSmartMeterInterest } from "./imbpSmartMeterInterest"
import {
  SmartMeterInterest,
  SmartMeterInterestInterest as ImbpInterest,
} from "@/api/backofficeRest/generated/model"

function formatInterest(
  data?: ImbpInterest | null,
): SmartMeterInterestDetails | null {
  const entries = Object.entries(data ?? {})
  if (!entries.length) return null

  return entries.reduce((allInterests, [day, slots]) => {
    allInterests[day] = { am: slots?.am ?? false, pm: slots?.pm ?? false }
    return allInterests
  }, {} as SmartMeterInterestDetails)
}
export const ImbpSmartMeterInterestParser: IParser<
  IImbpSmartMeterInterest,
  SmartMeterInterest
> = {
  toDomain: (data: SmartMeterInterest) => {
    try {
      return new ImbpSmartMeterInterest(
        formatInterest(data.interest),
        data.comment ?? "",
      )
    } catch (error) {
      throw new ParseError(error)
    }
  },
}
